import ATableAccess from "./aTableAccess";

class SystemLogAccess extends ATableAccess {}

export default SystemLogAccess;
